import BaseAPI from '../api'
const path = 'employees'
const app_path = 'app-employees'
export interface EmployeesInterface {
    idEmployee?: number
    employeeFirstname?: string
    employeeLastname?: string
    email?: string
    password?: string
    idDepartment?: number
    idRole?: number
    idPosition?: number
    fax?: string
    tel?: string
    permission?: any
    employeeStatus?: string
    page?: number;
    limit?: number;
    keyword?: string;
    sortBy?: string;
    sortType?: string;
}

export default class EmployeesApi extends BaseAPI {

    static getAllEmployees(props: EmployeesInterface): Promise<any> {
        return this.api.get(`${path}`, { params: { ...props } })
            .then((res) => res)
    }
    static getNewEmployee(idEmployee: number): Promise<any> {
        return this.api.get(`${path}/${idEmployee}`, {})
            .then((res) => res)
    }
    static getEmployees(props: EmployeesInterface): Promise<any> {
        return this.api.get(`${app_path}`, { params: { ...props } })
            .then((res) => res)
    }
    static postEmployees(props: EmployeesInterface): Promise<any> {
        return this.api.post(`${app_path}`, { ...props }, {})
            .then((res) => res)
    }
    static patchEmployees(idEmployee: number, props: EmployeesInterface): Promise<any> {
        return this.api.patch(`${app_path}/${idEmployee}`, { ...props }, {})
            .then((res) => res)
    }
    static getEmployee(idEmployee: number): Promise<any> {
        return this.api.get(`${app_path}/${idEmployee}`, {})
            .then((res) => res)
    }
}
